// Intercom has been disabled - no longer in use
// import { useEffect } from "react";
// import Intercom from "@intercom/messenger-js-sdk";
// import { useSelector } from "react-redux";
// import Cookies from "js-cookie";

const ChatComponent = () => {
  // Intercom initialization disabled - no longer in use
  // const currentSession = useSelector(
  //   (state) => state?.sessions?.currentSession
  // );
  // const currentUser = useSelector((state) => state?.[currentSession]?.user);

  // useEffect(() => {
  //   if (!currentSession || !currentUser) return;

  //   try {
  //     Intercom({
  //       app_id: process.env.REACT_APP_INTERCOM_APP_ID,
  //       user_id: ["userSession", "privateProviderSession"].includes(
  //         currentSession
  //       )
  //         ? currentUser?.user?.customerId
  //         : currentUser?.user?.customerId + "_" + currentUser?.subuser?.email,
  //       name: currentUser?.user?.personal?.[0]?.firstName,
  //       email: ["userSession", "privateProviderSession"].includes(
  //         currentSession
  //       )
  //         ? currentUser?.user?.email
  //         : currentUser?.subuser?.email,
  //       user_hash: Cookies.get(process.env.REACT_APP_INTERCOM_MSG_C_N),
  //       created_at: ["userSession", "privateProviderSession"].includes(
  //         currentSession
  //       )
  //         ? currentUser?.user?.createdAt
  //         : currentUser?.subuser?.createdAt,
  //     });
  //   } catch (err) {
  //     console.warn("Intercom failed to initialize", err);
  //   }
  // }, [currentSession, currentUser]);

  return null;
};

export default ChatComponent;
